import React from 'react';
import { Box, Typography } from '@mui/material';
import PaymentButton from '../../Components/PaymentButton';

const PaymentScreen: React.FC = () => {
  const amountInPaise = 1000; // ₹10

  const handlePaymentSuccess = (response: any) => {
    console.log('Payment successful:', response);
    alert('Payment Successful!');
  };

  const handlePaymentError = (error: any) => {
    console.error('Payment failed:', error);
    alert('Payment failed. Please try again.');
  };

  return (
    <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Razorpay Payment
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Pay ₹{amountInPaise / 100} using your card via Razorpay
      </Typography>

      <PaymentButton
        userData={{
          name: 'Test user',
          // email: 'test@test.com',
          contact: '9876543210',
        }}
        amount={amountInPaise}
        currency="INR"
        paymentFor="trip_booking"
        referenceId="687c9342c2e4b1d3787dd26f"
        onPaymentSuccess={handlePaymentSuccess}
        onPaymentError={handlePaymentError}
        buttonText="Pay Now"
        sx={{ mt: 3 }}
      />
    </Box>
  );
};

export default PaymentScreen; 